import React from "react";
import { useDispatch, useSelector } from "react-redux";

import HeaderRight from "./HeaderRight";
import TopSearch from "./TopSearch";
import {
  toggleClientBulkUploadModal,
  toggleMobileDrawer,
} from "../../../../reducers/clientcommon";

/** Inline hamburger icon — avoids adding an icon library dependency */
const HamburgerIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

/**
 * Function to render the client header, including user information and action buttons.
 *
 * @return {JSX.Element} The rendered client header component
 */
const ClientHeader = () => {
  const { user } = useSelector((state) => state.clientProfile);
  const dispatch = useDispatch();
  const { isPremiumAccount, clientUserAllPermissions } = useSelector(
    (state) => state.session,
  );

  const handleToOpenBulkUploadModal = () => {
    dispatch(toggleClientBulkUploadModal(true));
  };
  return (
    <>
      <div
        className={`ClientHeader_Wrapper sticky top-0 z-50 flex min-h-[56px] items-center bg-white px-3 py-2 transition duration-300 md:min-h-[70px] md:px-[30px] md:py-3`}
      >
        <div className="flex w-full items-center justify-between gap-2 md:gap-4">
          <div className="flex grow !select-none items-center gap-2 md:gap-4">
            {/* Hamburger menu — mobile only */}
            <button
              className="grid h-[44px] w-[44px] flex-shrink-0 place-items-center rounded-lg text-primary hover:bg-grey md:hidden"
              onClick={() => dispatch(toggleMobileDrawer(true))}
              aria-label="Open navigation"
            >
              <HamburgerIcon />
            </button>
            <TopSearch />
          </div>
          <div className="hidden md:flex">
            <HeaderRight />
          </div>
          {/* <HeaderBulkUploadContracts /> */}
        </div>
      </div>
    </>
  );
};

export default ClientHeader;
